export const RESET = 'EXCMTEAM_UPDATE_RESET'
export const SET_ERROR = 'EXCMTEAM_UPDATE_SET_ERROR'
export const SET_RETRIEVED = 'EXCMTEAM_UPDATE_SET_RETRIEVED'
export const SET_UPDATED = 'EXCMTEAM_UPDATE_SET_UPDATED'
export const SET_VIOLATIONS = 'EXCMTEAM_UPDATE_SET_VIOLATIONS'
export const TOGGLE_LOADING = 'EXCMTEAM_UPDATE_TOGGLE_LOADING'
export const UPDATE_RETRIEVED = 'EXCMTEAM_UPDATE_UPDATE_RETRIEVED'
